import { /* makeStyles, Theme, */ Typography } from "@material-ui/core";
import React from "react";
import navigationImage from "./Assets/navigation.svg";
import payImage from "./Assets/pay.svg";
import videoImage from "./Assets/video.svg";
import talentImage from "./Assets/talent.svg";
import Categories from "./Categories";
import CategoryData from "./CategoryData";
import ContactInformation from "./WDContactInformation";

// const useStyles = makeStyles((theme: Theme) => ({}));

const categories = [
  {
    title: "Getting Started",
    icon: navigationImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "Getting Started in Workday",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8716-a456-4de8-aa7c-386720f37071",
          },
          {
            title: "Time Off for a Direct Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8712-a456-4de8-aa7c-386720f37071",
          },
          {
            title: "Requisition Overview",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8719-a456-4de8-aa7c-386720f37071",
          },
        ],
        jobAids: [
          {
            title: "Delegating Inbox",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ad56-4de8-aa7c-386720f37071",
          },
          {
            title: "Workday Mobile Setup",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ah56-4de8-aa7c-386720f37071",
          },
          {
            title: "PINGID",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/62440067-88dc-4e81-881e-672f20ce6a6d",
          },
          {
            title: "Access Workday from a Kiosk",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/d8c89f64-3fa7-4603-9338-8710d0fc6b5c",
          },
          {
            title: "HR Cheat Sheet",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/1f947625-f6be-40bf-90a1-a184b05fca2f",
          },
        ],
      },
    ],
  },
  {
    title: "HR Partner Go Begin Tasks",
    icon: payImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "Form I-9 Demo in Workday",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0e84bebd-000e-4a3a-96f1-5091d2edd2be",
          },
        ],
        jobAids: [
          {
            title: "Generating Reports",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/913af9e5-1a5a-42d2-862d-433431b05f4d",
          },
          {
            title: "Managing Dashboards",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/4718c226-cb4c-4918-9998-4274c77f20c7",
          },
          {
            title: "Onboarding",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/f693ebb9-4e52-401b-ab64-9b650a92cd64",
          },
          {
            title: "Leave of Absence Management",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-am56-4de8-aa7c-386720f37071",
          },
          {
            title: "HRBP Role Chart",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/141f3bad-d7b4-4835-a0ae-5597836df5fa",
          },
          {
            title: "HR Comparable Reports",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/40360e7d-11d5-4388-847f-b3c4850738a1",
          },
          {
            title: "HR Partner I-9 Form Completion",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/26ffc567-973a-4b05-80aa-38f5f95e06cb",
          },
        ],
      },
    ],
  },
  {
    title: "Manager Visibility",
    icon: payImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [],
        jobAids: [
          {
            title: "Creating Job Requisition",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/5c60f002-3cf2-4dd4-afbd-22c914b8f7ec",
          },
          {
            title: "Onboarding a New hire",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/f693ebb9-4e52-401b-ab64-9b650a92cd64",
          },
          {
            title: "Terminations",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/e20fdc1d-a5e7-414b-8d2e-6e39d05b0b39",
          },
          {
            title: "Promotions",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/5528a24b-a304-4725-bf64-2b8e8332315f",
          },
          {
            title: "Shift Change",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ar56-4de8-aa7c-386720f37071",
          },
          {
            title: "Kronos Management for Nonexempt Employees",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ai56-4de8-aa7c-386720f37071",
          },
          {
            title: "RemedyForce Service Request Tasks - Contractor Access Form",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/8fbaa2aa-056b-4edd-91be-23b13473fe9d",
          },
          {
            title: "Manage Contingent Worker",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/f1e7024e-a412-414a-be50-65cffcbe6ecb",
          },
        ],
      },
    ],
  },
  {
    title: "HR Business Partner Training Sessions",
    icon: talentImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "HR Business Partner Session 1",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/3e3e8a76-2ffd-435d-8bea-06ca6b189764",
          },
          {
            title: "HR Business Partner Session 2",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/98210436-d03d-45ba-9150-91413aa5cb3a",
          },
          {
            title: "HR Business Partner Session 3",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/8bd1b386-d324-49ee-b552-1ef541b7e39a",
          },
          {
            title: "HR Business Partner Session 4",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/80b5134c-0fdd-45c8-98f5-51d3541d364d",
          },
          {
            title: "HR Business Partner Refresher Training",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/a6c8ad96-e279-4d50-857d-6032f3127309",
          },
        ],
        jobAids: [],
      },
    ],
  },
] as CategoryData[];

export default function HRBusPartnerLinks() {
  // const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h4">Quick Links for HR Partner</Typography>

      <br />
      <Categories data={categories} />
      <br />

      <ContactInformation />
    </React.Fragment>
  );
}
